<template>
  <CreateEditLessonModal
    v-if="showCreateEditLessonModal"
    :courseId="courseId"
    :moduleId="moduleId"
    @closeModal="closeCreateEditLessonModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else>
    <div class="text-end">
      <button
        v-if="courseSelected.status == 2"
        type="button"
        class="btn btn-primary"
        title="Cadastrar Aula"
        @click="showCreateEditLessonModal = true"
      >
        Cadastrar Aula
      </button>
    </div>
    <div v-if="lessons.length > 0" class="row">
      <div class="col-lg-5 mt-3">
        <ListLessons
          :lessons="lessons"
          :lessonIdSelected="lessonIdSelected"
          @detailsLesson="detailsLesson"
        />
      </div>
      <div class="col-lg-7 mt-3">
        <DetailsLesson
          v-if="showDetailsLesson"
          :courseId="courseId"
          :moduleId="moduleId"
          :lessonId="lessonIdSelected"
          @loadListLessons="getLessons"
        />
        <div v-else class="card card-body text-center h-100">
          <h4 v-if="lessonIdSelected == null">
            Selecione uma aula para visualizar os detalhes
          </h4>
        </div>
      </div>
    </div>
    <p v-else class="text-center mb-0">
      Este módulo não possui nenhuma aula cadastrada
    </p>
  </div>
</template>

<script>
import CreateEditLessonModal from '@/components/courses/lessons/CreateEditLessonModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListLessons from '@/components/courses/lessons/ListLessons.vue'
import DetailsLesson from '@/components/courses/lessons/DetailsLesson.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'LessonsModules',

  components: {
    CreateEditLessonModal,
    LoadingData,
    ListLessons,
    DetailsLesson,
  },

  props: {
    courseId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditLessonModal: false,
      showDetailsLesson: false,
      lessons: [],
      lessonIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['courseSelected']),
  },

  methods: {
    async getLessons() {
      try {
        this.lessons = await this.$store.dispatch('getLessons', {
          courseId: this.courseId,
          moduleId: this.moduleId,
        })
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeCreateEditLessonModal(loadListLessons) {
      if (loadListLessons) {
        this.getLessons()
      }
      this.showCreateEditLessonModal = false
    },

    detailsLesson(lessonId) {
      this.lessonIdSelected = lessonId
      this.showDetailsLesson = false
      setTimeout(() => {
        this.showDetailsLesson = true
      }, 200)
    },
  },

  mounted() {
    this.getLessons()
  },
}
</script>
